import React, { Component } from 'react';
import { Modal, Radio, Form, Row, Col, Input, Cascader } from 'antd';
import { connect } from 'dva';
import { getAppCode } from '../../../../utils/utils';
import styles from './index.less';

const FormItem = Form.Item;
const createForm = Form.create;

@connect()
class ModifyModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      disabled: false,
    };
  }

  handleOk = () => {
    const { form, record = {} } = this.props;
    const { id = '' } = record;
    form.validateFields((err, values) => {
      if (!err) {
        const params = {
          id,
          appid: values.appid,
          publish: values.publish,
          push: values.push,
          secret: values.secret,
          subscribeName: values.subscribeName,
          channelId: values.channelId[values.channelId.length - 1],
          appCode: getAppCode(),
        };
        this.fetchAllConfigure(params);
      }
    });
  };

  fetchAllConfigure = params => {
    const { fetchAllConfigure, closeModifyModal } = this.props;
    const { dispatch } = this.props;
    this.setState({ disabled: true });
    dispatch({
      type: 'publicSetting/fetchSaveConfigure',
      params,
    })
      .then(() => {
        this.setState({
          disabled: false,
        });
        closeModifyModal();
        fetchAllConfigure({ appCode: getAppCode() });
      })
      .catch(() => {
        this.setState({ disabled: false });
      });
  };

  handleCancel = () => {
    const { form, closeModifyModal } = this.props;
    closeModifyModal();
    form.resetFields();
    this.setState({ disabled: false });
  };

  render() {
    const { disabled } = this.state;
    const { form } = this.props;
    const { getFieldProps } = form;
    const { modifyModalVisible, type, record = {}, channelList = [] } = this.props;
    const {
      subscribeName = '',
      appid = '',
      secret = '',
      publish = 0,
      push = 0,
      channelId = '',
      superiorChannelId = '',
    } = record;

    const layout = {
      labelCol: {
        span: 6,
      },
      wrapperCol: {
        span: 15,
      },
    };

    const isChannelId = channelId ? [channelId] : '';

    const initialId = superiorChannelId ? [superiorChannelId, channelId] : isChannelId;

    const subscribeNameItem = getFieldProps('subscribeName', {
      initialValue: subscribeName,
      rules: [{ required: true, message: '公众号名称不能为空' }],
    });
    const appidItem = getFieldProps('appid', {
      initialValue: appid,
      rules: [{ required: true, message: 'AppID不能为空' }],
    });
    const secretItem = getFieldProps('secret', {
      initialValue: secret,
      rules: [{ required: true, message: 'AppSecret不能为空' }],
    });
    const channelIdItem = getFieldProps('channelId', {
      initialValue: initialId,
      rules: [{ required: true, message: '同步栏目不能为空' }],
    });
    const publishItem = getFieldProps('publish', {
      initialValue: publish,
      rules: [{ required: false, message: '' }],
    });
    const pushItem = getFieldProps('push', {
      initialValue: push,
      rules: [{ required: false, message: '' }],
    });

    return (
      <Modal
        title={type === '新增' ? '新增公众号' : '编辑公众号'}
        centered
        visible={modifyModalVisible}
        onOk={this.handleOk}
        onCancel={this.handleCancel}
        okText="确定"
        className={styles.modifyModal}
        confirmLoading={disabled}
        width={580}
        maskClosable={false}
      >
        <Form horizontal>
          <div className="tips">
            勾选自动发布/自动推送后，由公众号同步的文章将直接发布/推送成功，不经过审批。
          </div>
          <Row>
            <Col span={24}>
              <FormItem {...layout} label="公众号名称">
                <Input {...subscribeNameItem} placeholder="请输入" />
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <FormItem {...layout} label="AppID">
                <Input {...appidItem} placeholder="请输入" disabled={type === '修改'} />
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <FormItem {...layout} label="AppSecret">
                <Input {...secretItem} placeholder="请输入" />
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <FormItem {...layout} label="同步栏目">
                <Cascader {...channelIdItem} options={channelList} placeholder="请选择发布的栏目" />
              </FormItem>
            </Col>
          </Row>
          <div className="tips">公众号同步微官网</div>
          <Row className="publish">
            <Col span={24}>
              <FormItem {...layout} label="自动发布">
                <Radio.Group {...publishItem}>
                  <Radio value={1}>是</Radio>
                  <Radio value={0}>否</Radio>
                </Radio.Group>
              </FormItem>
            </Col>
            <Col span={24}>
              <FormItem {...layout} label="自动推送">
                <Radio.Group {...pushItem}>
                  <Radio value={1}>是</Radio>
                  <Radio value={0}>否</Radio>
                </Radio.Group>
              </FormItem>
            </Col>
          </Row>
        </Form>
      </Modal>
    );
  }
}

const ModifyModalForm = createForm()(ModifyModal);

export default ModifyModalForm;
